// import { useState } from "react";
// import styles from "./Chathomescreen.module.css";
// import chipsData from "./Chathomechips.json";

// /* ─── SVG icons ─────────────────────────────────────────────────────────── */

// const SparkleIcon = ({ size = 20, color = "#fff" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
//     <path d="M12 2l1.6 5.6L19 9l-5.4 1.4L12 16l-1.6-5.6L5 9l5.4-1.4L12 2z" />
//     <path d="M19 14.5l.7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3z" opacity="0.85" />
//   </svg>
// );

// const StethoscopeIcon = ({ size = 18, color = "#ef4444" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M6 4v6a3 3 0 0 0 6 0V4" />
//     <path d="M9 10v2a6 6 0 0 0 6 6h0" />
//     <circle cx="19" cy="16" r="3" />
//   </svg>
// );

// const DoctorIcon = ({ size = 18, color = "#f97316" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M18 21v-1.5a4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4V21" />
//     <circle cx="11.5" cy="7" r="3.5" />
//     <circle cx="19" cy="18.5" r="3.2" fill={color} opacity="0.12" stroke="none" />
//     <line x1="19" y1="17" x2="19" y2="20" />
//     <line x1="17.5" y1="18.5" x2="20.5" y2="18.5" />
//   </svg>
// );

// const PregnancyIcon = ({ size = 18, color = "#eab308" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M12 20.5s-7-4.6-9.4-8.9C1.1 8.6 2.8 5 6.4 5c2.1 0 3.4 1.3 5.6 3.6C14.2 6.3 15.5 5 17.6 5c3.6 0 5.3 3.6 3.8 6.6C19 15.9 12 20.5 12 20.5z" />
//   </svg>
// );

// const HormoneIcon = ({ size = 18, color = "#22c55e" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 12a9 9 0 1 1-3.3-6.95" />
//     <polyline points="21 3 21 9 15 9" />
//   </svg>
// );

// const MindIcon = ({ size = 18, color = "#6366f1" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1 4.6-11.6 8.4 8.4 0 0 1 3.5-.7h.5a8.48 8.48 0 0 1 8 8v.5z" />
//   </svg>
// );

// const ChevronRightIcon = ({ size = 18 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="9 18 15 12 9 6" />
//   </svg>
// );

// const SendIcon = ({ size = 16, color = "#fff" }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="22" y1="2" x2="11" y2="13" />
//     <polygon points="22 2 15 22 11 13 2 9 22 2" fill={color} stroke="none" />
//   </svg>
// );

// /* ─── Icon key -> component map (driven by JSON "icon" field) ───────────── */
// const ICON_MAP = {
//   stethoscope: StethoscopeIcon,
//   doctor: DoctorIcon,
//   pregnancy: PregnancyIcon,
//   hormone: HormoneIcon,
//   mind: MindIcon,
// };

// /* ─── Component ───────────────────────────────────────────────────────── */
// export default function ChatCareNavigatorWelcomeScreen({ patientName, onSelect, onBack }) {
//   const [message, setMessage] = useState("");

//   const handleSend = () => {
//     const trimmed = message.trim();
//     if (!trimmed) return;
//     // Route through the same "ask" id the free-text chat entry already uses.
//     onSelect?.("ask", { message: trimmed });
//     setMessage("");
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       handleSend();
//     }
//   };

//   return (
//     <div className={styles.container}>
//       {/* Header */}
//       {/* <div className={styles.header}>
//         <div className={styles.avatarCircle}>
//           <SparkleIcon size={20} />
//         </div>
//         <div className={styles.headerText}>
//           <p className={styles.headerTitle}>AI Care Navigator</p>
//           <p className={styles.headerSubtitle}>Your personal health assistant</p>
//         </div>
//         <div className={styles.onlineWrap}>
//           <span className={styles.onlineDot} />
//           <span className={styles.onlineText}>Online</span>
//         </div>
//       </div> */}

//       {/* Body */}
//       <div className={styles.body}>
//         <div className={styles.greetingBubble}>
//           Hi{patientName ? ` ${patientName}` : " there"}! 👋 I'm your AI Care
//           Navigator. How can I help you today?
//         </div>

//         <div className={styles.chipList}>
//           {chipsData.map((chip) => {
//             const Icon = ICON_MAP[chip.icon];
//             return (
//               <button
//                 key={chip.id}
//                 type="button"
//                 className={styles.chipRow}
//                 onClick={() => onSelect?.(chip.id)}
//               >
//                 <span
//                   className={styles.chipIconSquare}
//                   style={{ background: chip.bg }}
//                 >
//                   {Icon && <Icon size={18} color={chip.color} />}
//                 </span>
//                 <span className={styles.chipTextWrap}>
//                   <p className={styles.chipTitle}>{chip.title}</p>
//                   <p className={styles.chipSubtitle}>{chip.subtitle}</p>
//                 </span>
//                 <span className={styles.chevron}>
//                   <ChevronRightIcon size={18} />
//                 </span>
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Footer / composer */}
//       <div className={styles.footer}>
//         <div className={styles.inputRow}>
//           <input
//             className={styles.textInput}
//             placeholder="Type your message..."
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             onKeyDown={handleKeyDown}
//           />
//           <button
//             type="button"
//             className={styles.sendBtn}
//             onClick={handleSend}
//             disabled={!message.trim()}
//           >
//             <SendIcon size={15} />
//           </button>
//         </div>
//         <p className={styles.disclaimer}>
//           This is not a substitute for medical advice.
//         </p>
//       </div>
//     </div>
//   );
// }

import { useState } from "react";
// import styles from "./ChatCareNavigatorWelcomeScreen.module.css";
import styles from "./Chathomescreen.module.css";
import chipsData from "./Chathomechips.json";
import { MicIcon, SendIcon } from "../icons";
import useVoiceChat from "../../../hooks/useVoiceChat";

/* ─── SVG icons (chip / header art — not covered by the shared icon set) ── */

const SparkleIcon = ({ size = 20, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2l1.6 5.6L19 9l-5.4 1.4L12 16l-1.6-5.6L5 9l5.4-1.4L12 2z" />
    <path d="M19 14.5l.7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3z" opacity="0.85" />
  </svg>
);

const StethoscopeIcon = ({ size = 18, color = "#ef4444" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 4v6a3 3 0 0 0 6 0V4" />
    <path d="M9 10v2a6 6 0 0 0 6 6h0" />
    <circle cx="19" cy="16" r="3" />
  </svg>
);

const DoctorIcon = ({ size = 18, color = "#f97316" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 21v-1.5a4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4V21" />
    <circle cx="11.5" cy="7" r="3.5" />
    <circle cx="19" cy="18.5" r="3.2" fill={color} opacity="0.12" stroke="none" />
    <line x1="19" y1="17" x2="19" y2="20" />
    <line x1="17.5" y1="18.5" x2="20.5" y2="18.5" />
  </svg>
);

const PregnancyIcon = ({ size = 18, color = "#eab308" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20.5s-7-4.6-9.4-8.9C1.1 8.6 2.8 5 6.4 5c2.1 0 3.4 1.3 5.6 3.6C14.2 6.3 15.5 5 17.6 5c3.6 0 5.3 3.6 3.8 6.6C19 15.9 12 20.5 12 20.5z" />
  </svg>
);

const HormoneIcon = ({ size = 18, color = "#22c55e" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12a9 9 0 1 1-3.3-6.95" />
    <polyline points="21 3 21 9 15 9" />
  </svg>
);

const MindIcon = ({ size = 18, color = "#6366f1" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 11.5a8.4 8.4 0 0 1-8.5 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1 4.6-11.6 8.4 8.4 0 0 1 3.5-.7h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const ChevronRightIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const ICON_MAP = {
  stethoscope: StethoscopeIcon,
  doctor: DoctorIcon,
  pregnancy: PregnancyIcon,
  hormone: HormoneIcon,
  mind: MindIcon,
};

/* ─── Component ───────────────────────────────────────────────────────── */
export default function ChatCareNavigatorWelcomeScreen({
  patientName,
  onSelect,
  onBack,
  onClose,
  lang = "en",
}) {
  const [message, setMessage] = useState("");

  // Same voice hook ChatScreen/VoiceScreen use — auto-sends after a pause.
  const {
    isListening,
    liveText,
    micError,
    toggleMic,
    isSpeechSupported,
  } = useVoiceChat({
    lang,
    autoSend: true,
    silenceMs: 1800,
    onSendText: (capturedText) => {
      // Route captured speech the same way a typed + sent message would.
      onSelect?.("ask", { message: capturedText });
    },
  });

  const hasText = message.trim().length > 0;

  const handleSend = () => {
    const trimmed = message.trim();
    if (!trimmed) return;
    onSelect?.("ask", { message: trimmed });
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isListening) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      {/* <div className={styles.header}>
        <div className={styles.avatarCircle}>
          <SparkleIcon size={20} />
        </div>
        <div className={styles.headerText}>
          <p className={styles.headerTitle}>AI Care Navigator</p>
          <p className={styles.headerSubtitle}>Your personal health assistant</p>
        </div>
        <div className={styles.onlineWrap}>
          <span className={styles.onlineDot} />
          <span className={styles.onlineText}>Online</span>
        </div>
      </div> */}

      {/* Body */}
      <div className={styles.body}>
        <div className={styles.greetingBubble}>
          Hi{patientName ? ` ${patientName}` : " there"}! 👋 I'm your AI Care
          Navigator. How can I help you today?
        </div>

        <div className={styles.chipList}>
          {chipsData.map((chip) => {
            const Icon = ICON_MAP[chip.icon];
            return (
              <button
                key={chip.id}
                type="button"
                className={styles.chipRow}
                onClick={() => onSelect?.(chip.id)}
              >
                <span
                  className={styles.chipIconSquare}
                  style={{ background: chip.bg }}
                >
                  {Icon && <Icon size={18} color={chip.color} />}
                </span>
                <span className={styles.chipTextWrap}>
                  <p className={styles.chipTitle}>{chip.title}</p>
                  <p className={styles.chipSubtitle}>{chip.subtitle}</p>
                </span>
                <span className={styles.chevron}>
                  <ChevronRightIcon size={18} />
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Footer / composer with voice support */}
      <div className={styles.footer}>
        <div className={styles.inputRow}>
          <input
            className={styles.textInput}
            placeholder={isListening ? "Listening…" : "Type your message..."}
            value={isListening ? liveText : message}
            onChange={(e) => !isListening && setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            readOnly={isListening}
          />

          {/* Smart toggle: mic when empty & idle, send once there's text or while listening */}
          {!hasText && !isListening ? (
            <button
              type="button"
              className={styles.sendBtn}
              onClick={toggleMic}
              disabled={!isSpeechSupported}
              title={isSpeechSupported ? "Speak" : "Voice not supported in this browser"}
            >
              <MicIcon size={15} color="#fff" />
            </button>
          ) : (
            <button
              type="button"
              className={styles.sendBtn}
              onClick={() => (isListening ? toggleMic() : handleSend())}
              title={isListening ? "Stop & send" : "Send"}
            >
              <SendIcon size={15} color="#fff" />
            </button>
          )}
        </div>

        {isListening && (
          <p className={styles.voiceHint}>🎤 Listening… sends automatically after a pause</p>
        )}
        {micError && <p className={styles.voiceError}>{micError}</p>}

        <p className={styles.disclaimer}>
          This is not a substitute for medical advice.
        </p>
      </div>
    </div>
  );
}